// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { MapInspectorAreaId } from './MapInspectorAreaId'
import {
  MapInspectorAreaNavigation,
  MapInspectorAreaNavigationIcon,
} from './MapInspectorAreaNavigation'
import { MapInspectorAreaRoutes } from './MapInspectorAreaRoutes'

const LazyMapInspectorComponent = lazy(() => import('./MapInspectorArea'))

const MapInspectorComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyMapInspectorComponent />
  </SuspenseLoadingWrapper>
)

export const MapInspectorArea = {
  id: MapInspectorAreaId,
  requiredRight: BoumRight.AREA_ADMIN_PANEL_MAP_INSPECTOR,
  Icon: MapInspectorAreaNavigationIcon,
  NavigationComponent: MapInspectorAreaNavigation,
  route: {
    path: MapInspectorAreaRoutes.route,
    component: MapInspectorComponent,
  },
}
